import React from 'react';

const NewsCategoryPage = React.lazy(() => import('pages/NewsCategory/NewsCategoryPage'));
const NewsCategoryAddPage = React.lazy(() => import('pages/NewsCategory/NewsCategoryAddPage'));

const NewsCategoryRoute = [
  {
    path: '/news-category',
    exact: true,
    name: 'Danh sách chuyên mục',
    function: 'NEWS_NEWSCATEGORY_VIEW',
    component: NewsCategoryPage,
  },
  {
    path: '/news-category/add',
    exact: true,
    name: 'Thêm mới chuyên mục',
    function: 'NEWS_NEWSCATEGORY_ADD',
    component: NewsCategoryAddPage,
  },
  {
    path: '/news-category/edit/:news_category_id',
    exact: true,
    name: 'Chỉnh sửa chuyên mục',
    function: 'NEWS_NEWSCATEGORY_EDIT',
    component: NewsCategoryAddPage,
  },
  {
    path: '/news-category/detail/:news_category_id',
    exact: true,
    name: 'Chi tiết chuyên mục',
    function: 'NEWS_NEWSCATEGORY_VIEW',
    component: NewsCategoryAddPage,
  },
];

export default NewsCategoryRoute;
